export default __webpack_public_path__ + "static/media/PrintsImage05.94c07414.jpg";